<template>
  <div class="data-section">
    <v-data-table class="data-table" :headers="headers" :items="visits" show-expand :expanded.sync="expanded" :loading-text="loadingText" loader-height="2" :loading="tableLoading" item-key="id" :item-class="isTransparent" hide-default-footer :mobile-breakpoint="1024" :server-items-length="totalVisits" :sort-by="defaultOrderBy" :sort-desc="defaultOrderByDesc" @update:options="serverSort">
      <template v-slot:item.patientFullName="{ item }">
        <span>{{ item.patientFullName ? item.patientFullName.trim() : '--' }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <CallUpStatusPin :visitItem="item"/>
      </template>
      <template v-slot:item.createDate="{ item }">
        <DateCell :date="item.createDate"/>
      </template>
      <template v-slot:item.callUpType="{ item }">
        <v-tooltip bottom :allow-overflow="true">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="22" class="ml-1">{{ typeIcon(item.callUpType) }}</v-icon>
          </template>
          <span>{{ typeText(item.callUpType) }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.callUpDate="{ item }">
        <DateCell :date="item.callUpDate"/>
      </template>
      <template v-slot:item.canRecall="{ item }">
        <CallUpRecall :visitItem="item" @updateCommonInfo="updateVisitInfo(item, $event)"/>
      </template>
      <template v-slot:item.callUpStatus="{ item }">
        <v-tooltip bottom :allow-overflow="true">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="22" :class="['ml-2', statusColor(item.callUpStatus)]">{{ statusIcon(item.callUpStatus) }}</v-icon>
          </template>
          <span>{{ statusText(item.callUpStatus) }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.visitOnPause="{ item }">
        <v-tooltip bottom :allow-overflow="true">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="item.visitOnPause" v-bind="attrs" v-on="on" size="23">mdi-pause-circle</v-icon>
          </template>
          <span>Pausesat</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="height: auto;" class="px-0">
          <CallUpExpanded :visitItem="item" @updateCommonInfo="updateVisitInfo(item, $event)"/>
        </td>
      </template>
    </v-data-table>
    <v-pagination color="#e0e6ec" v-model="queryParams.CurrentPage" :length="totalPages" :total-visible="7" class="py-4" :disabled="tableLoading" @input="changePageNumber"/>
    <v-divider/>
    <CallUpUpdateCSV/>
  </div>
</template>

<script>
  import CallUpExpanded from './CallUpExpanded';
  import CallUpUpdateCSV from './CallUpUpdateCSV';
  import api from '../../api/api';
  import CallUpStatusPin from './CallUpStatusPin';
  import CallUpRecall from './CallUpRecall';
  import DateCell from '../common/DateCell';

  export default {
    name: 'CallUpData',
    components: {DateCell, CallUpRecall, CallUpStatusPin, CallUpUpdateCSV, CallUpExpanded},

    data: function () {
      return {
        visits: [],
        expanded: [],
        loadingText: 'Loading... Please wait',
        defaultOrderBy: 'createDate',
        defaultOrderByDesc: true,
        totalVisits: 0,
        totalPages: 0,
        queryParams: {
          OrderBy: null,
          OrderByAscending: null,
          CurrentPage: 1,
          PageSize: 20,
        },
      };
    },

    computed: {
      isAdmin: function () {
        return this.$store.getters.isAdmin;
      },
      tableLoading: function () {
        return this.$store.state.callUp.tableLoading;
      },
      filterParams: function () {
        return this.$store.state.callUp.filterParams;
      },
      headers: function () {
        if (this.isAdmin) {
          return [
            {text: 'Nr.', value: 'id', width: '8%'},
            {text: 'CPR-nummer', value: 'patientCPR', width: '11%'},
            {text: 'Patient', value: 'patientFullName', width: '18%'},
            {text: 'Henv. dato', value: 'createDate'},
            {text: 'Status', value: 'status'},
            {text: 'Type', value: 'callUpType'},
            {text: 'Indkald. dato', value: 'callUpDate'},
            {text: 'Genindkald', value: 'canRecall', sortable: false},
            {text: 'Indkald', value: 'callUpStatus'},
            {value: 'visitOnPause', sortable: false, width: '55px', align: 'center'},
            {value: 'data-table-expand', sortable: false},
          ];
        } else {
          return [
            {text: 'Nr.', value: 'id', width: '8%'},
            {text: 'CPR-nummer', value: 'patientCPR', width: '11%'},
            {text: 'Patient', value: 'patientFullName', width: '18%'},
            {text: 'Henv. dato', value: 'createDate'},
            {text: 'Status', value: 'status'},
            {text: 'Type', value: 'callUpType'},
            {text: 'Indkald. dato', value: 'callUpDate'},
            {text: 'Genindkald', value: 'canRecall', sortable: false},
            {text: 'Indkald', value: 'callUpStatus'},
            {value: 'data-table-expand', sortable: false},
          ];
        }
      },
    },

    watch: {
      filterParams: function () {
        this.queryParams.CurrentPage = 1;
        this.getVisits();
      },
    },

    methods: {
      isTransparent: function (item) {
        let visible = false;
        for (let index = 0; index < this.filterParams.Statuses.length; index++) {
          const element = this.filterParams.Statuses[index];
          if (element === item.status) {
            visible = true;
            break;
          }
        }
        if (!visible) return 'transparent-area';
      },
      sortOrderValue: function (val) {
        switch (val.sortBy[0]) {
          case 'id':
            return 1;
          case 'patientCPR':
            return 2;
          case 'patientFullName':
            return 3;
          case 'createDate':
            return 4;
          case 'status':
            return 6;
          case 'callUpType':
            return 7;
          case 'callUpDate':
            return 8;
          case 'callUpStatus':
            return 9;
          default:
            return 0;
        }
      },
      serverSort: function (val) {
        this.queryParams.OrderBy = this.sortOrderValue(val);
        this.queryParams.OrderByAscending = !val.sortDesc[0];
        this.getVisits();
      },
      changePageNumber: function (value) {
        this.queryParams.CurrentPage = value;
        this.getVisits();
      },
      getVisits: async function () {
        try {
          this.visits = [];
          this.expanded = [];
          this.$store.commit('callUp/updateTableLoading', true);
          let {data} = await api.getIncalls({...this.queryParams, ...this.filterParams});
          let entities = data.paginationResult.entities;
          this.totalPages = Math.ceil(
            data.paginationResult.totalEntities / this.queryParams.PageSize,
          );
          this.visits = entities;
          this.totalVisits = data.paginationResult.totalEntities;
          this.$store.commit('callUp/updateTableLoading', false);
        } catch (e) {
          this.visits = [];
          this.expanded = [];
          this.$store.commit('callUp/updateTableLoading', false);
        }
      },
      updateVisitInfo: function (visitItem, newVisitItem) {
        for (let index = 0; index < this.visits.length; index++) {
          if (this.visits[index].id === visitItem.id) {
            this.$set(this.visits, index, newVisitItem);
            break;
          }
        }
      },
      typeIcon: function (type) {
        let names = {
          0: 'mdi-at',
          1: 'mdi-email',
          2: 'mdi-message-text',
          3: 'mdi-alpha-e-box'
        };
        return names[type];
      },
      typeText: function (type) {
        let text = {
          0: 'Email',
          1: 'Brev',
          2: 'SMS',
          3: 'e-Boks'
        };
        return text[type];
      },
      statusIcon: function (status) {
        let names = {
          1: 'mdi-timer-outline',
          2: 'mdi-alert-circle',
          3: 'mdi-check-circle',
          4: 'mdi-alert-circle',
        };
        return names[status];
      },
      statusColor: function (status) {
        let colors = {
          1: '',
          2: 'deep-orange--text  text--accent-4',
          3: 'teal--text ',
          4: 'deep-orange--text  text--accent-2',
        };
        return colors[status];
      },
      statusText: function (status) {
        let text = {
          1: 'Igangværende',
          2: 'Mislykkedes',
          3: 'Succes',
          4: 'Fejl hemmelig adresse',
        };
        return text[status];
      },
    },
  };
</script>
